export const blockIconsPhotoandimageGridOnNew = (
	<span className='material-symbols-outlined'>grid_on</span>
);
